import Image from 'next/image'
import styles from './_moreCoursesItem.module.scss'
import { t } from '../../../../utils'
import { MarketingCourseCategoryEnum } from '../../../../utils/marketing_courses_data'

const moreCoursesImages = {
  [MarketingCourseCategoryEnum.ElectricAcousticGuitar]: require('@public/images/lab/marketing_more_courses_guitar.png'),
  [MarketingCourseCategoryEnum.WorshipLeaderVocals]: require('@public/images/lab/marketing_more_courses_vocals.png'),
  [MarketingCourseCategoryEnum.BassGuitar]: require('@public/images/lab/marketing_more_courses_bass.png'),
  [MarketingCourseCategoryEnum.KeysPianoSynth]: require('@public/images/lab/marketing_more_courses_keys.png'),
  [MarketingCourseCategoryEnum.Drums]: require('@public/images/lab/marketing_more_courses_drums.png')
}

const MoreCoursesItem: React.FC<{
  category: MarketingCourseCategoryEnum
}> = ({ category }) => {
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <div className={styles.imgContainer}>
          <Image
            src={moreCoursesImages[category]}
            alt={t('Worship Online Lab+')}
          />
        </div>

        <div className={styles.textContainer}>
          <h3>{t('Plus many more trainings')}</h3>
          <p>({t('with new ones added every month')})</p>

          <p className={styles.price}>
            {t('Retail Price')}: $<del>594</del>
            <br />
            {t('Included with Membership')}
          </p>
        </div>
      </div>
    </section>
  )
}

export default MoreCoursesItem
